import { Link } from 'react-router-dom';

function Navbar(): JSX.Element {
  return (
    <nav className="bg-bgGreen border-b border-[#A2D8D5] py-4 md:py-8 sticky top-0 z-50 ">
      <div className="flex w-full justify-between md:px-12 px-4 py-1">
        <div className="flex w-full items-center justify-between">
          <div className="flex w-full items-center space-x-3">

            <Link to="/">

              <img
                className="h-[20px] md:h-[35px]  w-auto"
                alt="Group"
                src="https://saraluat.blr1.cdn.digitaloceanspaces.com/redemption_portal/fincentive%20logo.png"
              />

            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-2 text-sm ">
            <img
            className='h-[15px]'
              alt="Vector"
              src="https://saraluat.blr1.cdn.digitaloceanspaces.com/redemption_portal/secure%20logo.png"
            />            
            <span className='text-textGreen text-[15px] font-semibold w-[150px] whitespace-nowrap'>SSL Secured</span>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 